import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

{
  const { pathname, search, hash } = window.location
  const clean = pathname.replace(/\/index\.html?$/, "").replace(/(.)\/+$/, "$1") || "/"
  if (clean !== pathname) window.history.replaceState(null, "", clean + search + hash)
}

createRoot(document.getElementById("root")!).render(<App />);
